import { Link } from 'react-router-dom'

interface BackToDashboardLinkProps {
  className?: string
}

export default function BackToDashboardLink({
  className = ''
}: BackToDashboardLinkProps) {
  return (
    <Link
      to="/admin"
      className={`text-[#A6410A] hover:text-[#894d35] font-medium ${className}`}
    >
      ← Back to Dashboard
    </Link>
  )
}
